import styled, { css } from "styled-components";
import { MoreVertIcon } from "../../../../Previews/Svg";

export const PINTEREST_IMAGE_SIZE_SPEC = {
  // Allowed aspect ratio: 2:3
  web: {
    width: 578,
    pictureWidth: 270,
    minHeight: 405,
    maxHeight: 405
  },
  mobile: {
    width: 578,
    pictureWidth: 270,
    minHeight: 405,
    maxHeight: 405
  }
};

export const PhotoEditorWrapper = styled.div`
  flex: 1 1 auto;
  z-index: 2;
`;

export const Details = styled.div`
  width: 50%;
  text-align: left;
`;

export const TeaserEditorWrapper = styled.div`
  margin-left: -8px;
  max-width: 260px;
`;

export const DetailsHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const Dots = styled(MoreVertIcon)`
  height: 20px;
  margin-left: -3px;
`;

export const NoticeButton = styled.a`
  background-color: #e21132;
  color: white;
  border-radius: 50px;
  border: none;
  padding: 8px 20px;
  font-size: 11px;
  font-weight: 600;
  height: 28px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    color: white;
    background-color: #ce001e;
  }
`;
export const URLWrapper = styled.div`
  color: #b2b2b2;
  font-size: 11px;
`;
export const DetailsFooter = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 0;
`;

export const TitleEditor = styled.div`
  margin: 10px 0 10px -8px;
`;

export const Page = styled.div`
  display: flex;
  align-items: center;
`;

export const PageName = styled.div`
  color: #1c1c1d;
  font-weight: 600;
`;

export const PageFollowers = styled.div`
  color: #5b6169;
`;

export const PageLogo = styled.img`
  height: 40px;
  width: 40px;
  border-radius: 30px;
  margin-right: 12px;
`;

export const FollowButton = styled.div`
  background-color: #efefef;
  color: #717071;
  z-index: 1;
  border-radius: 50px;
  border: none;
  padding: 8px 20px;
  font-size: 11px;
  font-weight: 600;
  height: 28px;
`;

export const PostEditorWrapper = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px 0px #1516331f;

  display: flex;
  gap: 20px;
  padding: 20px;

  ${(props) =>
    props.mobile
      ? css`
          width: ${PINTEREST_IMAGE_SIZE_SPEC.mobile.width}px;
        `
      : css`
          width: ${PINTEREST_IMAGE_SIZE_SPEC.web.width}px;
        `}
`;

export const teaserTextStyle = {
  fontSize: "13px",
  fontWeight: 400,
  color: "#5b6169",
  lineHeight: 1.25
};

export const titleStyle = {
  fontSize: "24px",
  fontWeight: "800",
  color: "#1c1c1d"
};
